import { reputation } from '@/mocks/services';

export default function Reputation() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-sm font-medium mb-4">
            客户口碑
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            被信任，是我们最大的成就
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">
            来自不同行业品牌合作伙伴的真实评价
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {reputation.map((item, index) => (
            <div key={index} className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-7">
              <div className="flex gap-1 mb-4">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-accent-400 text-sm"></i>
                ))}
              </div>
              <blockquote className="text-sm text-foreground-700 leading-relaxed mb-5 italic">
                "{item.quote}"
              </blockquote>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-primary-600 font-bold text-sm">{item.author.charAt(0)}</span>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-900">{item.author}</div>
                  <div className="text-xs text-foreground-500">{item.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}